import { InjectionToken } from '@angular/core';

import { ResponseErrorsInterface } from '@pe/checkout/types';

export interface HandleErrorResult {
  canRetry?: boolean;
  message: string;
  title: string;
}

export interface HandleErrorInterface {
  handleError(response: ResponseErrorsInterface): HandleErrorResult;
}

export const HANDLE_ERROR_STRATEGY = new InjectionToken<HandleErrorInterface>('HANDLE_ERROR_STRATEGY');
